<template>
    <button
        class="btn btn-link"
        style="min-width: 0; padding-left: 2.25rem"
        type="button"
    >
        <icon icon="cil-plus" style="position: absolute; left: 19px" />
        <slot>
            {{ trans('general.action.add_new') }}
        </slot>
    </button>
</template>
<script>
export default {
    name: 'button-add-new',
};
</script>
